// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9h7bR","title":"styles_title__mAjAI"};